import { Resources } from 'constants/resources';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { queryClient } from 'providers/queryClient';
import { useNotify } from 'react-admin';
import { DeleteDialog } from 'shared/mui/Dialogs';
import { TypographyWithBold } from 'shared/mui/Typography';
import { Commission } from 'types/embedded/commission';

type Props = {
  record?: Commission;
  open: boolean;
  onClose: () => void;
};

export const MerchantCommissionsDeleteDialog = ({ onClose, open, record }: Props) => {
  const translate = useTypedTranslate();
  const notify = useNotify();

  const onSuccess = async () => {
    await queryClient.invalidateQueries({ queryKey: [Resources.Commissions] });
    onClose();
    notify(
      <TypographyWithBold
        text={translate('app.merchantCommissions.itemDeleted', { name: record?.name || '' })}
      />,
      { type: 'success' },
    );
  };

  return (
    <DeleteDialog
      details={translate('app.merchantCommissions.feeWillBeDeleted', { name: record?.name })}
      onClose={onClose}
      onSuccess={onSuccess}
      open={open}
      record={record}
      title={translate('app.merchantCommissions.feeDeletion')}
    />
  );
};
